<!--
    Summary:
        媒体中心
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-media">
    <banner>
      <img src="../../assets/images/about/Header_1920x380_gallery.jpg"/>
      <div slot="title">{{$t('Media.Title')}}</div>
    </banner>

    <!-- 精准的基因检测 x 专业的医疗服务 -->
    <card class="galleries">
      <div slot="title">{{$t('Media.P1Title')}}</div>

      <div class="gallery">
        <!-- 报告查询 -->
        <div class="box active" >
          <div class="img-wrapper">
            <img src="../../assets/images/about/fclab-folder.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_1Detail')}}<br/>{{$t('Media.P1_1Detail2')}}
            </p>
            <a href="/#/search" class="a-btn">{{$t('Media.P1_1Button')}}</a>
          </div>
        </div>

        <!-- 基因天地 -->
        <div class="box">
          <div class="img-wrapper">
            <img src="../../assets/images/about/fc-flyer.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_2Detail')}}<br/>{{$t('Media.P1_2Detail2')}}
            </p>
            <a href="/#/gensuniverse" class="a-btn">{{$t('Media.P1_2Button')}}</a>
          </div>
        </div>

        <!-- 获奖证书 -->
        <div class="box">
          <div class="img-wrapper">
            <img src="../../assets/images/about/fclab-award.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_3Detail')}}<br/>{{$t('Media.P1_3Detail2')}}
            </p>
            <a target="_blank" href="../../../static/WGO-certificate.pdf" class="a-btn">{{$t('Media.P1_3Button')}}</a>
          </div>
        </div>
      </div>

      <div class="gallery">
        <!-- 科研技术 -->
        <div class="box active" >
          <div class="img-wrapper">
            <img src="../../assets/images/about/fclab-pipette2.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_4Detail')}}<br/>{{$t('Media.P1_4Detail2')}}
            </p>
            <a href="/#/technology" class="a-btn">{{$t('Media.P1_4Button')}}</a>
          </div>
        </div>


        <!-- 认证资质 -->
        <div class="box">
          <div class="img-wrapper">
            <img src="../../assets/images/about/fclab-blood-tube.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_5Detail')}}<br/>{{$t('Media.P1_5Detail2')}}
            </p>
            <a href="/#/accreditation" class="a-btn">{{$t('Media.P1_5Button')}}</a>
          </div>
        </div>

        <!-- 合作 -->
        <div class="box">
          <div class="img-wrapper">
            <img src="../../assets/images/about/fc-shatin3.jpg"/>
          </div>
          <div class="shade">
            <p>
              {{$t('Media.P1_6Detail')}}<br/>{{$t('Media.P1_6Detail2')}}
            </p>
            <a href="/#/partnership" class="a-btn">{{$t('Media.P1_6Button')}}</a>
          </div>
        </div>
      </div>

    </card>

  </div>
</template>

<script>
  import banner from '@/components/banner'
  import card from '@/components/card'
  import hoverBox from '@/components/hover-box'

  var hover = function () {
    $('.gallery .box').on('mouseenter', function (e) {
      let $this = $(this);
      $this.parent().children().removeClass('active');
      $this.addClass('active');
    });
  }
  export default {
    components: {
      banner,
      card,
      hoverBox
    },
    data() {
      return {}
    },
    mounted() {
      hover();
    },
    methods: {},
  }
</script>
<style scoped lang="scss">
  .v-media {
    
    text-align: left;

    .galleries{
      margin-bottom: 30px;
    }
    .gallery {
      display: flex;
      margin-bottom: 20px;

      .box {
        display: flex;
        overflow: hidden;
        position: relative;
        width: 290px;
        margin-right: 20px;
        flex-shrink: 0;

        .img-wrapper {
          flex-shrink: 0;
          z-index: 1;
          width: 290px;

          img {
            width: 100%;
          }
        }

        .shade {
          position: absolute;
          left: 0;
          top: 0;
          flex-shrink: 0;
          z-index: 0;
          width: 270px;
          transition: all .5s;
          margin: 20px 0;
          overflow: hidden;
          white-space: nowrap;
          .a-btn {
            margin-top: 20px;
          }
        }

        transition: all .5s;
        &.active {
          width: 580px;
          .shade {
            left: 310px;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/about/media.vue